<template>
  <v-dialog v-model="loading" persistent width="300">
    <v-card :color="error ? 'error' : 'primary'" dark>
      <v-card-title>{{ prompt || (error ? "加载失败" : "正在加载") }}</v-card-title>
      <v-card-text>
        <v-progress-linear
          :indeterminate="!(progress >= 0)"
          :query="isNaN(progress)"
          :value="progress"
          color="white"
          v-if="!error"
        />
        {{ progressText }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props : [
    "loading",
    "progress",
    "progressText",
    "prompt",
    "error"
  ]
}
</script>